import React, { useEffect, useState } from "react";
import { ResponsiveRadar } from "@nivo/radar";
import { diagnosisService } from "@/stores/services/diagnosisServices";
import { useSearchParams } from "react-router-dom";
import { decryptId } from "@/utils/utilsMethods";
import { skipToken } from "@reduxjs/toolkit/query";
import { Skeleton } from "antd";

interface ReportDiagnosisProps {
  companyId: number;
}

const typesCycle = {
  P: "PLANEAR",
  H: "HACER",
  V: "VERIFICAR",
  A: "ACTUAR",
} as const;

export default function ReportDiagnosis({ companyId }: ReportDiagnosisProps) {
  const [data, setData] = useState<Record<string, unknown>[]>([]);
  const [searchParams] = useSearchParams();
  const diagnosisParam = searchParams.get("diagnosis");
  const diagnosisId = diagnosisParam
    ? parseInt(decryptId(diagnosisParam))
    : undefined;

  const { data: fetchRadar, isFetching } = diagnosisService.useRadarChartQuery(
    diagnosisId && diagnosisId > 0
      ? { companyId, diagnosisId }
      : skipToken,
  );

  useEffect(() => {
    if (fetchRadar && fetchRadar.length > 0) {
      const transformedData = fetchRadar.map((radar) => ({
        cycle: typesCycle[radar.cycle.toUpperCase() as keyof typeof typesCycle] ?? radar.cycle,
        porcentage: radar.cycle_percentage ?? 0,
      })) as Record<string, unknown>[];
      setData(transformedData);
    } else {
      setData([]);
    }
  }, [companyId, fetchRadar]);

  return (
    <div className="flex h-[27rem] w-full items-center justify-center">
      {isFetching ? (
        <Skeleton active paragraph={{ rows: 6 }} className="w-full" />
      ) : data.length > 0 ? (
        <ResponsiveRadar
          data={data}
          keys={["porcentage"]}
          indexBy="cycle"
          maxValue="auto"
          margin={{ top: 70, right: 80, bottom: 40, left: 80 }}
          curve="linearClosed"
          borderWidth={2}
          borderColor={{ from: "color" }}
          gridLabelOffset={36}
          dotSize={10}
          dotColor={{ theme: "background" }}
          dotBorderWidth={2}
          dotBorderColor={{ from: "color" }}
          colors={"#0066B2"}
          fillOpacity={0.25}
          blendMode="multiply"
          animate={true}
          motionConfig="wobbly"
        />
      ) : (
        <span className="text-gray-500">Sin datos para el gráfico</span>
      )}
    </div>
  );
}
